import request from "@/api/axios";
import { SYSTEM_SERVICE } from "@/api/config/servicePort";

export const getDataSetListCacheByTypeNameApi = (params: any, noLoading: boolean = true): Promise<IResponse> => {
  return request.get({ url: SYSTEM_SERVICE + `/customdata/set/list/cache/${params.type_name}`, params }, { noLoading });
};

export const getDataSetListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: SYSTEM_SERVICE + "/customdata/set/list", params });
};

// 自定义数据集类型列表
export const getDataSetTypeListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: SYSTEM_SERVICE + "/customdata/type/list", params });
};
